import styled from 'styled-components';
import theme from '../../theme';

const StyledSuccessMessage = styled.div`
  .custom-note{
    background-color: '#F1F2F7';
    padding: '20px';
    border-radius: '12px';
  }
  .info-icon{
    width: 75px;
    height: 75px;
    object-fit: contain;
  }
  .note-info{
    font-size: 16px;
    margin-top: 20px;
    color: ${theme.vividBlue};
  }
  .icon-blue{
    font-size: 60px;
    color: ${theme.vividBlue};
  }
`;

export default StyledSuccessMessage;



// WEBPACK FOOTER //
// client/containers/NsdlRequestStatement/SuccessMessage.js